module.exports = __webpack_public_path__ + "static/media/done-4.d40f642c.png";